module.exports = __webpack_public_path__ + "img/close.75626e8b.png";